import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap'

import CanvasJSChart from '@canvasjs/vue-charts';

import '../public/assets/css/style.css'

import '../public/assets/css/responsive.css'


import 'leaflet/dist/leaflet.css';




createApp(App).use(store).use(router).use(CanvasJSChart).mount('#app')
